import React from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Collaborators from "../components/Sections/Collaborators";
import Initiatives from "../components/Sections/Initiatives";
import Team from "../components/Sections/Team";
import Objectives from "../components/Sections/Objectives";
import WorkingTogether from "../components/Sections/WorkingTogether";
import Contact from "../components/Sections/Contact";
import Donate from "../components/Sections/Donate";
import Footer from "../components/Sections/Footer"

export default function Landing() {
  return (
    <>
      <TopNavbar />
      <Header />
      <WorkingTogether />
      <Initiatives />
      <Collaborators />
      <Objectives />
      <Team />
      <Contact />
      <Donate />
      <Footer />
    </>
  );
}


